module.exports = __webpack_public_path__ + "static/media/goods9.d63f1cc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/goods9.png
// module id = 439
// module chunks = 0